/**
 * Incident-date helpers (Beta-1 plan P5-16, LAUNCH-TODO). Pure module.
 *
 * The synthesis workflow used to fall back to 2024-01-01 when a report did not state the incident
 * date, so every undated case study showed "January 1, 2024". Treat that sentinel — and any
 * Jan-1 date with no supporting month/day evidence — as "date not stated" in the renderer.
 */
export const INCIDENT_DATE_SENTINELS = Object.freeze(['2024-01-01', '2024-01-01T00:00:00.000Z', '2024-01-01T00:00:00Z']);

/** Convert a Firestore Timestamp / ISO string / Date into a Date, or null. */
export function toDate(value) {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value === 'string' || typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  return null;
}

/** True when the incident date is real (not the 2024-01-01 placeholder or an unparsable value). */
export function isKnownIncidentDate(value) {
  if (!value) return false;
  if (typeof value === 'string' && INCIDENT_DATE_SENTINELS.includes(value.trim())) return false;
  const d = toDate(value);
  if (!d) return false;
  // Sentinel stored as a Timestamp: Jan 1 2024 exactly at midnight UTC.
  if (d.getTime() === Date.UTC(2024, 0, 1)) return false;
  return true;
}

/** Display string for an incident date, or null when unknown (callers fall back to createdAt / "Date not stated"). */
export function formatIncidentDate(value, options = { year: 'numeric', month: 'long', day: 'numeric' }) {
  if (!isKnownIncidentDate(value)) return null;
  return toDate(value).toLocaleDateString('en-US', options);
}
